import React, { useEffect, useState } from "react";
import { apiClient } from "../lib/api";
import { Calendar } from "lucide-react";
import { fmtDate } from "../lib/format";

export default function CurrencyMarquee() {
  const [rates, setRates] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const r = await apiClient.get("/currency/latest");
        if (!cancelled) setRates(r.data || []);
      } catch {
        if (!cancelled) setRates([]);
      }
    };
    load();
    const id = setInterval(load, 5 * 60 * 1000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  if (!rates.length) {
    return (
      <div
        className="bg-sidebar text-sidebar-foreground border-b border-sidebar-border text-xs uppercase tracking-[0.25em] py-2 px-6"
        data-testid="currency-marquee-empty"
      >
        Carregando cotações…
      </div>
    );
  }

  // Most recent captured date across all quotes to display as a fixed prefix
  const latestDate = rates.reduce((acc, q) => {
    const d = String(q.captured_at || "").slice(0, 10);
    return d > acc ? d : acc;
  }, "");

  // Duplicate items to enable seamless marquee
  const items = [...rates, ...rates];

  return (
    <div
      className="relative flex items-stretch bg-sidebar text-sidebar-foreground border-b border-sidebar-border"
      data-testid="currency-marquee"
    >
      {/* Fixed date pill — always visible on the left */}
      <div
        className="shrink-0 flex items-center gap-2 px-4 py-2 bg-sidebar-primary/10 border-r border-sidebar-border text-xs uppercase tracking-[0.22em] text-sidebar-primary"
        data-testid="currency-marquee-date"
      >
        <Calendar className="w-3.5 h-3.5" />
        <span className="font-mono-tab normal-case tracking-normal text-foreground">
          {latestDate ? fmtDate(latestDate) : "—"}
        </span>
      </div>
      <div className="relative overflow-hidden py-2 flex-1">
        <div className="marquee-track px-6">
          {items.map((q, idx) => (
            <div
              key={`${q.code}-${idx}`}
              className="flex items-center gap-3 text-xs uppercase tracking-[0.22em]"
              data-testid={`currency-item-${q.code.toLowerCase()}`}
            >
              <span className="text-sidebar-primary font-medium">{q.code}/BRL</span>
              <span className="font-mono-tab text-foreground/80 normal-case tracking-normal">
                R$ {Number(q.rate_to_brl).toFixed(4)}
              </span>
              <span className="text-muted-foreground normal-case tracking-normal text-[10px]">
                {q.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
